import Commons from '../../../../Services/Common/Common';

/**
 * NOT_BASIC_01 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 조회 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapParamsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(coCd 등)을 context로 넘겨줄 수 있다.
 */
export const NOT_BASIC_01_Schema = {
  fields: {
    coCd: { initial: '', label: '회사코드' },
    coNm: { initial: '', label: '회사' },
    noticeYn: { initial: 'N', label: '공지여부' },
    gubun: { initial: '', label: '구분' },
    gubunNm: { initial: '', label: '구분명' },
    gubunDtlNm: { initial: '', label: '구분 상세' },
    title: { initial: '', label: '제목' },
    comment: { initial: '', label: '내용' },
    endDate: { initial: '', label: '종료일' },
  },

  mapper: {
    search1: {
      CoCd: (_, context) => {
        // 시스템 계정일 경우 회사 검색조건으로 검색
        const coCdValue =
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd;
        return Commons.EncryptAES(coCdValue) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.custCd || '') || '',
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
  },
};
